module.exports = __webpack_public_path__ + "static/media/bonair5.99576ece.JPG";